import React from 'react';
import { Route, Switch } from 'react-router';
import SurveyConfirmation from './scenes/SurveyConfirmation';
import DeliveryOrder from './scenes/DeliveryOrder';
import InterventionOrder from './scenes/InterventionOrder';
import InformationPage from './scenes/InformationPage';

const CrmRouter = () => {
  return (
    <Switch>
      <Route path='/delivery-order' component={DeliveryOrder} />
      <Route path='/intervention-order' component={InterventionOrder} />
      <Route path='/informations' component={InformationPage} />
      <Route path='/survey/confirmation' component={SurveyConfirmation} />
    </Switch>
  );
};

export default CrmRouter;
